import { render } from "./Home.vue?vue&type=template&id=0fcebcb9"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=0fcebcb9&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__